import m from "../../geodata/es2015/saintLuciaHigh";
window.am4geodata_saintLuciaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saintLuciaHigh.js
// module id = null
// module chunks = 